import Modal from 'components/Modal';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import service from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { useHistory } from 'react-router-dom';

const DeleteDocuments = () => {
  const t = utils.intl.useTranslator();
  const idUser = useSelector(selectors.user.getIdUser);
  const programCode = useSelector(selectors.app.getProgramCode);
  const documentCompany = useSelector(selectors.documents.selectActiveDocument)?.idCompany;
  const documentsID = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const dispatch = useDispatch();
  const [errorProtocols, setErrorProtocols] = useState<number[]>([]);
  const [ErroModalVisibilyty, setErrorModalVisibility] = useState(false);
  const [ErrorModal] = utils.hooks.useBulkActionErrorModal(errorProtocols, ErroModalVisibilyty);
  const isEditView = utils.documents.isOpenDocumentView();
  const history = useHistory();

  const confirm = async () => {
    try {
      if (idUser) {
        const { data } = await service.deleteDocuments({
          protocols: documentsID,
          idCompany: documentCompany,
          idProgram: programCode,
          idUser,
        });
        let protocolArrToBeDeleted = [...documentsID];
        if (!data.success) {
          if (isEditView) {
            utils.app.notify('warning', t('delete-documents-warning'));
            dispatch(actions.modal.closeModal());
            return;
          }
          setErrorProtocols(data.protocols);
          setErrorModalVisibility(true);
          protocolArrToBeDeleted = protocolArrToBeDeleted.filter((protocol) => !data.protocols.includes(protocol));
          utils.app.notify('warning', t('delete-documents-warning'));
        } else {
          dispatch(actions.modal.closeModal());
          if (isEditView) dispatch(actions.documents.openNextDocument(history));
          utils.app.notify('success', t('documents-successfully-deleted'));
        }
        dispatch(actions.documents.removeRows(protocolArrToBeDeleted));
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      {ErroModalVisibilyty ? (
        <ErrorModal />
      ) : (
        <>
          <Modal.Header title={t('Warning')} subtitle={t('deleting-document')} />
          <Modal.Footer
            confirmText={t('confirm')}
            confirmAction={confirm}
            closeButtonText={t('cancel')}
          />
        </>
      )}
    </>
  );
};

export default DeleteDocuments;
